import { Chakra } from "@airhelp/react-ui-components";
import { useTranslations } from "contexts/LocalizationContext";
import NextLink from "next/link";
import type { MenuItemsProps } from "./MenuItems.d";

const { Stack, Link } = Chakra;

const MenuItems = ({ menuItems, onClose }: MenuItemsProps) => {
  const translations = useTranslations();

  return (
    <Stack
      flexGrow={{ lg: 1 }}
      fontWeight="bold"
      spacing={{ base: 10, lg: 8 }}
      direction={{ base: "column", lg: "row" }}
      justifyContent="right"
    >
      {menuItems.map(({ title, href }) => (
        <NextLink href={href} key={title} passHref>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <Link
            color="inherit"
            onClick={onClose}
            title={translations(title)}
            _visited={{}}
            _hover={{ color: "primary.500", textDecoration: "none" }}
          >
            {translations(title)}
          </Link>
        </NextLink>
      ))}
    </Stack>
  );
};

export default MenuItems;
